import(/* webpackMode: "eager" */ "/vercel/path0/app/planes/page.tsx");
